import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageTitle, Panel, Field, TextInput, Btn, StatCard } from "../components/ui";
import { useI18n } from "../i18n";
import { CL } from "../api";

export default function Targets() {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { CL.getTargets().then(setD).catch(() => {}); }, []);
  if (!d) return null;
  const up = (k) => (e) => { const v = e.target.value; setD((p) => ({ ...p, [k]: v })); };
  const num = (v) => (v === "" || v == null ? 0 : Number(v));

  const save = async () => {
    setSaving(true);
    try {
      const saved = await CL.putTargets({
        base_year: num(d.base_year) || 2024, base_emissions_t: num(d.base_emissions_t),
        target_year: num(d.target_year) || 2030, reduction_pct: num(d.reduction_pct),
        sbti_aligned: !!d.sbti_aligned, note: d.note || "",
      });
      setD((p) => ({ ...p, ...saved }));
      const fresh = await CL.getTargets(); setD(fresh);
      toast.success(t("saved"));
    } catch { toast.error("Error"); } finally { setSaving(false); }
  };

  return (
    <div data-testid="targets-page">
      <PageTitle title={t("targetsTitle")} subtitle={t("targetsDesc")} />
      <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-3">
        <StatCard testId="target-current" label={t("currentEmissions")} value={(d.current_t ?? 0).toLocaleString()} sub={t("tCO2e")} />
        <StatCard testId="target-goal" label={t("targetEmissions")} value={(d.target_emissions_t ?? 0).toLocaleString()} sub={t("tCO2e")} accent="#2f8f5b" />
        <StatCard testId="target-progress" label={t("progress")} value={`%${d.progress_pct ?? 0}`} accent="#e08a1e" />
      </div>
      <Panel className="max-w-2xl">
        <div className="mb-5 h-3 overflow-hidden rounded-full bg-[#eef1e9]">
          <div className="h-full rounded-full bg-[#14512f]" style={{ width: `${Math.min(100, d.progress_pct || 0)}%` }} />
        </div>
        <div className="grid grid-cols-2 gap-5">
          <Field label={t("baseYear")}><TextInput type="number" data-testid="target-base-year" value={d.base_year ?? ""} onChange={up("base_year")} /></Field>
          <Field label={t("baseEmissions")}><TextInput type="number" data-testid="target-base-em" value={d.base_emissions_t ?? ""} onChange={up("base_emissions_t")} /></Field>
          <Field label={t("targetYear")}><TextInput type="number" data-testid="target-year" value={d.target_year ?? ""} onChange={up("target_year")} /></Field>
          <Field label={t("reductionPct")}><TextInput type="number" data-testid="target-pct" value={d.reduction_pct ?? ""} onChange={up("reduction_pct")} /></Field>
        </div>
        <label className="mt-4 flex items-center gap-2 text-sm text-[#3a423b]">
          <input type="checkbox" data-testid="target-sbti" checked={!!d.sbti_aligned} onChange={(e) => setD((p) => ({ ...p, sbti_aligned: e.target.checked }))} />
          {t("sbtiAligned")}
        </label>
        <div className="mt-6"><Btn onClick={save} disabled={saving} data-testid="target-save">{saving ? "..." : t("save")}</Btn></div>
      </Panel>
    </div>
  );
}
